import SectionTitle from "../../../common/sectionTitle";
import data from "../../../assets/data/partnerData";
import PartnerStyledWrapper from "./Partner.style";
import partner from "../../../assets/images/octopuses/nft-crypto-world.mp4"
const Partner = () => {
  return (
    <PartnerStyledWrapper>
      <div className="our_partners_sect">
        <div className="container">
          <SectionTitle
            isCenter={true}
            subtitle="AS SEEN IN"
            title="Our Partners"
            className="text-center"
          />
          <div className="our_partnar_content">
          {/* <video autoPlay loop muted={1} style={{width:"85vw",height:"55vh"}} >
            <source src={partner} type="video/mp4" />
          </video> */}
            <ul>
              {data?.map((logo, i) => (
                <li key={i}>
                  <img src={logo} alt="ALPHA OCTOPUS Partners"  style={{height:"100%"}}/>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </PartnerStyledWrapper>
  );
};

export default Partner;
